import { render, staticRenderFns } from "./ItemDrop.vue?vue&type=template&id=6230eeb0&scoped=true&"
import script from "./ItemDrop.vue?vue&type=script&lang=js&"
export * from "./ItemDrop.vue?vue&type=script&lang=js&"
import style0 from "./ItemDrop.vue?vue&type=style&index=0&id=6230eeb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6230eeb0",
  null
  
)

export default component.exports